import type { Store } from '../../types';
import bossApi from '../../utils/fetch-api';

export const getAuthorizedStores = async ({ accessToken, locale }: { accessToken: string; locale?: string }) => {
  const stores = await bossApi<Store[]>('/store/v2/stores', {
    m2m: false,
    token: accessToken,
    preserveErrorStatus: true,
    locale: locale ?? null,
  });

  return stores ?? [];
};

export default getAuthorizedStores;
